export default {
  Alkanes: [
    {
      name: "Methane",
      formula: "CH4",
      description:
        "Methane is a chemical compound with the chemical formula CH4. It is a group-14 hydride and the simplest alkane, and is the main constituent of natural gas. The relative abundance of methane on Earth makes it an attractive fuel, although capturing and storing it poses challenges due to its gaseous state under normal conditions for temperature and pressure.",
      filename: "methane.pdb",
    },
    {
      name: "Ethane",
      formula: "C2H6",
      description:
        "Ethane is a chemical compound with chemical formula C2H6. At standard temperature and pressure, ethane is a colorless, odorless gas. Ethane is isolated on an industrial scale from natural gas, and as a byproduct of petroleum refining.",
      filename: "ethane.pdb",
    },
    {
      name: "Propane",
      formula: "C3H8",
      description: "Propane is...",
      filename: "propane.pdb",
    },
    {
      name: "Butane",
      formula: "C4H10",
      description: "Butane is...",
      filename: "butane.pdb",
    },
    {
      name: "Pentane",
      formula: "C5H12",
      description: "Pentane is...",
      filename: "pentane.pdb",
    },
    {
      name: "Hexane",
      formula: "C6H14",
      description: "Hexane is...",
      filename: "hexane.pdb",
    },
  ],
  Alkenes: [
    {
      name: "Ethene",
      formula: "C2H4",
      description: "Ethene is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Propene",
      formula: "C3H6",
      description: "Propene is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Butene",
      formula: "C4H8",
      description: "Butene is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Pentene",
      formula: "C5H10",
      description: "Pentene is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Hexene",
      formula: "C6H12",
      description: "Hexene is...",
      filename: "caffeine.pdb",
    },
  ],
  Alcohols: [
    {
      name: "Methanol",
      formula: "CH3OH",
      description: "Methanol is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Ethanol",
      formula: "C2H5OH",
      description: "Ethanol is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Propanol",
      formula: "C3H7OH",
      description: "Propanol is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Butanol",
      formula: "C4H9OH",
      description: "Butanol is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Pentanol",
      formula: "C5H11OH",
      description: "Pentanol is...",
      filename: "caffeine.pdb",
    },
    {
      name: "Hexanol",
      formula: "C6H13OH",
      description: "Hexanol is...",
      filename: "caffeine.pdb",
    },
  ],
  Other: [
    {
      name: "Aspirin",
      formula: "C9H8O4",
      description:
        "Aspirin, chemically known as acetylsalicylic acid, is a widely used medication for its anti-inflammatory, analgesic, and antipyretic properties, effective in relieving pain, reducing inflammation, and lowering fever. Originating from willow bark extracts used for centuries, aspirin was first synthesized in 1897 by Felix Hoffmann, a chemist at Bayer AG. Beyond its immediate relief for minor aches and pains, aspirin's antiplatelet effects make it invaluable in preventing blood clots, thereby reducing the risk of heart attacks and strokes, particularly in individuals with a history of cardiovascular disease. However, its use is contraindicated in some individuals due to potential side effects, such as gastrointestinal ulcers and bleeding, particularly with long-term use. Recent studies have also explored aspirin's potential role in cancer prevention, particularly colorectal cancer, although its routine use for this purpose requires further investigation. Due to its wide-ranging applications and accessibility, aspirin remains a cornerstone in both over-the-counter and prescription medicine.",
      filename: "aspirin.pdb",
    },
    {
      name: "Buckyball",
      formula: "C60",
      description:
        "A Buckyball, officially known as Buckminsterfullerene (C60), is a spherical molecule composed of 60 carbon atoms arranged in a pattern of hexagons and pentagons, similar to a soccer ball. This structure is a type of fullerene, a class of carbon allotropes named after architect Buckminster Fuller, whose geodesic domes it resembles. Discovered in 1985 by scientists Harold Kroto, Richard Smalley, and Robert Curl, who later won the Nobel Prize in Chemistry for their work, Buckyballs are notable for their unique properties, including high strength, resilience, and the ability to conduct electricity under certain conditions. They have potential applications in materials science, electronics, and nanotechnology, with research exploring uses in drug delivery systems, lubricants, and even in the production of renewable energy sources. The discovery of Buckyballs also led to the identification of other fullerene structures, expanding the field of nanomaterials.",
      filename: "buckyball.pdb",
    },
    {
      name: "Caffeine",
      formula: "C8H10N4O2",
      description:
        "Caffeine is a natural stimulant most commonly found in tea leaves, coffee beans, and cacao pods. It works by blocking the action of adenosine, a neurotransmitter that relaxes the brain and makes you feel tired. Instead, it increases the activity of other neurotransmitters like dopamine and norepinephrine, leading to heightened alertness and energy. Consumed worldwide in beverages like coffee, tea, and energy drinks, caffeine is celebrated for its ability to ward off drowsiness and enhance focus and concentration. However, excessive consumption can lead to side effects such as insomnia, nervousness, restlessness, stomach irritation, and increased heart rate and blood pressure. Moderation is key, as individual sensitivity to caffeine can vary significantly.",
      filename: "caffeine.pdb",
    },
    {
      name: "Cholesterol",
      formula: "C27H46O",
      description:
        "Cholesterol is a vital waxy substance in the body, essential for making cell membranes, hormones, and vitamin D. It's transported through the bloodstream by lipoproteins: Low-Density Lipoprotein (LDL), known as bad cholesterol, can accumulate and form plaque in arteries, leading to heart disease; High-Density Lipoprotein (HDL) or good cholesterol, helps remove LDL. The liver produces most of the body's cholesterol, supplemented by dietary intake. High LDL levels pose a significant health risk, often managed by lifestyle changes and medications like statins. Understanding and managing cholesterol levels is crucial for preventing cardiovascular diseases and maintaining overall health.",
      filename: "cholesterol.pdb",
    },
    {
      name: "Diamond",
      formula: "C",
      description:
        "Diamond, a highly coveted gemstone, is a form of carbon where the atoms are arranged in a crystal structure known as a diamond lattice. Renowned for its unrivaled hardness, diamonds are the hardest known natural material, making them ideal for cutting, grinding, and polishing other substances. This crystalline carbon is formed under high-pressure, high-temperature conditions found deep within the Earth’s mantle, and is brought closer to the surface through volcanic eruptions. Diamonds have exceptional optical properties; they are able to disperse light, resulting in a characteristic sparkling appearance that has made them highly sought after for jewelry. Beyond their aesthetic allure, diamonds have substantial industrial applications due to their hardness and thermal conductivity, being used in cutting, grinding tools, and in high-performance heat sinks. The value of diamonds is assessed based on the Four Cs: cut, color, clarity, and carat weight, with clarity referring to the absence of internal imperfections or inclusions and color generally ranging from colorless to yellowish, with colorless stones being the most valued. Synthetic diamonds, created in laboratories, mimic the properties of natural diamonds and are used both in industry and as gemstones.",
      filename: "diamond.pdb",
    },
    {
      name: "Glucose",
      formula: "C6H12O6",
      description:
        "Glucose, a simple sugar and a key source of energy for living organisms, is a monosaccharide with the molecular formula C6H12O6. Found extensively in nature, it plays a pivotal role in cellular respiration and photosynthesis, acting as the primary energy currency in cells. Glucose is a building block for complex carbohydrates and is absorbed directly into the bloodstream during digestion, leading to its common reference as blood sugar. Its levels in the human body are tightly regulated by hormones such as insulin and glucagon, ensuring a balance that is crucial for proper metabolic function. Glucose can exist in several structural forms, including D-glucose, which is biologically active. In its crystalline form, glucose is a white, odorless, sweet-tasting powder, soluble in water, and used in various medical treatments and as a dietary supplement. Additionally, it serves as a fundamental starting material in the fermentation process for producing ethanol in alcoholic beverages and biofuels, showcasing its versatile applications in both biological and industrial contexts.",
      filename: "glucose.pdb",
    },
    {
      name: "Graphite",
      formula: "C",
      description:
        "Graphite is a naturally occurring form of crystalline carbon that is renowned for its remarkable properties, which include high thermal and electrical conductivity, and its ability to act as a lubricant. It is distinct from its carbon cousin, diamond, due to its hexagonal atomic structure, which confers upon it a high degree of anisotropy, meaning its properties vary significantly in different directions. Graphite is soft, with a metallic luster and a gray to black color. It is used in a wide range of applications, from the familiar lead in pencils, where its ability to leave a mark on paper comes from its layered, flaky structure, to roles in high-temperature crucibles, batteries, and as a moderator in nuclear reactors. Its ability to withstand extreme temperatures and chemical inertness makes it valuable in industries requiring materials that can endure harsh conditions. Furthermore, graphite is pivotal in the development of emerging technologies such as lithium-ion batteries and as a potential material in the construction of graphene, a single-atom-thick sheet of carbon atoms arranged in a hexagonal lattice, noted for its extraordinary strength and conductivity.",
      filename: "graphite.pdb",
    },
    {
      name: "LSD",
      formula: "C20H25N3O",
      description:
        "LSD (Lysergic Acid Diethylamide) is a powerful, synthetic hallucinogen, known for its significant psychological effects. Discovered in 1938 by Swiss chemist Albert Hofmann, LSD is derived from ergotamine, a substance found in ergot, a fungus that grows on rye and other grains. It is typically consumed in very small quantities (micrograms), with its effects, known as a trip, lasting up to 12 hours. Users may experience dramatically altered perceptions of reality, including visual and auditory hallucinations, altered sense of time and space, and intense emotional swings. LSD's impact on the brain is believed to occur through interaction with serotonin receptors, influencing mood, cognition, and perception. Despite its controversial reputation and legal status in many countries, research into LSD's potential therapeutic effects, particularly for PTSD, depression, and addiction, has been undergoing a resurgence.",
      filename: "lsd.pdb",
    },
    {
      name: "Nicotine",
      formula: "C10H14N2",
      description:
        "Nicotine is a potent alkaloid found primarily in the leaves of the tobacco plant (Nicotiana tabacum) and is responsible for the addictive nature of tobacco products. This colorless to yellowish liquid acts as a stimulant in mammals, affecting the central nervous system and cardiovascular system. Nicotine mimics acetylcholine, a neurotransmitter, binding to nicotinic acetylcholine receptors and leading to increased release of neurotransmitters like dopamine, which contributes to its addictive properties. It has a dual effect on the body, capable of both stimulating and relaxing effects depending on the dose and the user's tolerance. Despite its widespread association with smoking, nicotine is also used in nicotine replacement therapies (NRT) like patches, gums, and e-cigarettes, aimed at helping individuals quit tobacco use.",
      filename: "nicotine.pdb",
    },
  ],
};
